<template>
  <icon v-if="lockedCategory" name="lock" />
</template>

<script>
import { mapState } from 'vuex';
import Icon from '@/lib/components/Shared/Icon.vue';

export default {
  components: {
    Icon
  },
  computed: {
    ...mapState('entryForm', ['locks']),
    lockedCategory() {
      return this.locks.lockedCategory;
    }
  }
};
</script>
